/** Anything we accept as an instant: a Date, an ISO-8601 string or epoch milliseconds. */
export type DateInput = Date | string | number;

/** Converts a {@link DateInput} to a new Date, throwing `RangeError` for invalid input. */
export function toDate(input: DateInput): Date {
  const date = input instanceof Date ? new Date(input.getTime()) : new Date(input);
  if (Number.isNaN(date.getTime())) {
    throw new RangeError(`Invalid date: ${String(input)}`);
  }
  return date;
}
